import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum NetworkStatusEnum {
  OFFLINE = 'offline',
  ONLINE = 'online',
}

export interface NetworkState {
  status: NetworkStatusEnum;
}

const initialState: NetworkState = {
  status: NetworkStatusEnum.ONLINE,
};

export const toastSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setNetworkStatus: (state, action: PayloadAction<NetworkStatusEnum>) => {
      state.status = action.payload;
    },
  },
});

export const { setNetworkStatus } = toastSlice.actions;

export default toastSlice.reducer;
